import { Link } from "react-router-dom";
import { hotManga } from "@/mocks/manga";

const hotCoverImages = [
  "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20featuring%20a%20powerful%20dark-haired%20hunter%20with%20piercing%20blue%20eyes%20in%20sleek%20black%20combat%20outfit%2C%20surrounded%20by%20ethereal%20blue%20system%20interface%20holograms%2C%20dramatic%20shadow%20effects%2C%20clean%20dark%20gradient%20background%2C%20premium%20manhwa%20illustration%20style%20with%20sharp%20details%20and%20cinematic%20lighting&width=800&height=1000&seq=hot-manga-cover-01&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Epic%20fantasy%20manga%20cover%20art%20featuring%20a%20young%20martial%20artist%20with%20black%20hair%20in%20flowing%20red%20robes%20wielding%20mystical%20flames%2C%20dramatic%20lighting%20with%20golden%20and%20crimson%20tones%2C%20clean%20simple%20background%20with%20subtle%20smoke%20effects%2C%20highly%20detailed%20illustration%20style%2C%20dynamic%20composition&width=800&height=1000&seq=hot-manga-cover-02&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20manga%20cover%20depicting%20two%20elegant%20cultivators%20in%20black%20and%20white%20robes%20playing%20guqin%20amidst%20a%20bamboo%20forest%2C%20ethereal%20misty%20atmosphere%20with%20soft%20moonlight%2C%20ink%20wash%20painting%20style%20mixed%20with%20detailed%20character%20art%2C%20serene%20and%20mystical%20mood&width=800&height=1000&seq=hot-manga-cover-03&orientation=portrait",
];

export default function HotRecommend() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14 md:mb-20">
          <h2 className="font-heading font-black text-3xl md:text-4xl text-foreground-900 tracking-tight">
            本周热门推荐
          </h2>
          <p className="mt-3 text-sm text-foreground-500">千万读者都在追的热门漫画，不容错过</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {hotManga.map((manga, index) => (
            <Link
              key={manga.id}
              to={`/article/${manga.id}`}
              className="group relative aspect-[4/5] rounded-2xl overflow-hidden cursor-pointer"
            >
              <img
                src={hotCoverImages[index]}
                alt={manga.title}
                title={`${manga.title} - 汗汗漫画热门推荐`}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                <h3 className="text-xl md:text-2xl font-black text-white font-heading text-center px-4">
                  {manga.title}
                </h3>
                <p className="mt-2 text-sm text-white/70">
                  {manga.status} · 更新至 {manga.latestChapter.split(" ")[0]}
                </p>
                <div className="mt-4 flex items-center gap-1.5">
                  <i className="ri-star-fill text-accent-400 text-sm"></i>
                  <span className="text-sm text-white/90 font-semibold">{manga.rating}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}